import {useEffect,useState} from 'react';
import {createPortal} from 'react-dom';
import Modal from '@/components/base/Modal';
import {useClient} from '@/hooks/useClient';
import type {ClubBenefit} from '@/types/content';
export default function BenefitDetailModal({benefit,onClose}:{benefit:ClubBenefit|null;onClose:()=>void}){
 const {client}=useClient();const [copied,setCopied]=useState(false);
 useEffect(()=>setCopied(false),[benefit?.id]);if(!benefit)return null;
 return createPortal(<Modal open onClose={onClose} title="Tu cupón ALÉA" footer={<button className="h-12 w-full rounded-full bg-primary-500 font-semibold text-background-50" onClick={onClose}>Listo</button>}>
  <div className="space-y-4 p-5">
   <div className="rounded-3xl border border-accent-300 bg-gradient-to-br from-accent-100 to-background-50 p-5">
    <p className="font-label text-xs font-bold tracking-[0.22em] text-accent-700">ALÉA CLUB</p>
    <h3 className="mt-3 font-heading text-2xl font-extrabold">{benefit.title}</h3>
    <p className="mt-2 text-sm leading-relaxed">{benefit.detail}</p>
    <div className="my-5 border-t border-dashed border-accent-400"/>
    <p className="text-xs text-foreground-600">Cupón de {client?.name}</p>
    <p className="mt-2 break-all font-heading text-xl font-extrabold tracking-wider">{benefit.couponCode}</p>
    {benefit.couponExpiresAt&&<p className="mt-3 text-xs">Válido hasta el 31 de octubre de 2026.</p>}
   </div>
   <p className="text-center text-sm">Muestra este código al cobrar en el negocio.</p>
   {benefit.id==='segunda-visita'&&<p className="text-center text-xs text-foreground-600">El facial se canjea en tu tercera cita, después de completar y pagar tus dos primeras visitas.</p>}
   <button className="h-12 w-full rounded-full border border-background-300 text-sm font-semibold" onClick={async()=>{try{await navigator.clipboard.writeText(benefit.couponCode||'');setCopied(true);}catch{setCopied(false);}}}>{copied?'Código copiado':'Copiar código'}</button>
  </div>
 </Modal>,document.body);
}
